module.exports = __webpack_public_path__ + "img/pr-3.0bd52584.png";